import { render } from "./projectReviewDetail.vue?vue&type=template&id=29a596fa&scoped=true"
import script from "./projectReviewDetail.vue?vue&type=script&lang=js"
export * from "./projectReviewDetail.vue?vue&type=script&lang=js"

import "./projectReviewDetail.vue?vue&type=style&index=0&id=29a596fa&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a596fa"]])

export default __exports__